// Guard Setup Wizardu - 3-stanowy (loading profilu / non-admin / admin).
//
// Dla admina sprawdza status setupu i przekierowuje na /managment_panel/setup
// dopoki nie ukonczy lub nie kliknie "Pomin teraz" (sessionStorage).
// Dla non-admina i nieautoryzowanych - pass-through (<Outlet />).

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useRoutes from 'routes/useRoutes';
import { Loader } from 'components/controls';
import { useGetSetupStatus } from 'api/endpoints';

const ADMIN_ROLE = 'ROLE_ADMIN';
const SETUP_PATH_SEGMENT = '/managment_panel/setup';
const SKIPPED_KEY = 'setupSkipped';

const fullScreenLoader = (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh'
    }}>
    <Loader />
  </div>
);

const WiseSetupGuard = () => {
  const { isProfileLoading, profile } = useRoutes();
  const location = useLocation();

  // Stan 1: profile loading
  if (isProfileLoading || profile === undefined || profile === null) {
    return fullScreenLoader;
  }

  // Stan 2: profile loaded, ale nie admin -> normalny dashboard
  const isAdmin = profile?.role === ADMIN_ROLE;
  if (!isAdmin) {
    return <Outlet />;
  }

  // Stan 3: admin -> sprawdz status setupu
  return <WiseSetupGuardAdmin pathname={location.pathname} />;
};

interface IWiseSetupGuardAdminProps {
  pathname: string;
}

const WiseSetupGuardAdmin = ({ pathname }: IWiseSetupGuardAdminProps) => {
  const skipped =
    typeof window !== 'undefined' && window.sessionStorage.getItem(SKIPPED_KEY) === 'true';

  const { data: setupStatus, isLoading } = useGetSetupStatus({
    // pominiecie zapytania jesli user juz pomijal w tej sesji - guard nie blokuje
    enabled: !skipped
  });

  if (skipped) {
    return <Outlet />;
  }

  if (isLoading) {
    return fullScreenLoader;
  }

  const isOnSetupPage = pathname.includes(SETUP_PATH_SEGMENT);
  const needsSetup = setupStatus && !setupStatus.is_completed;

  if (needsSetup && !isOnSetupPage) {
    return <Navigate to="/managment_panel/setup" replace />;
  }

  return <Outlet />;
};

export default WiseSetupGuard;
